import React from "react";
import { ArrowDown } from "lucide-react";
import { bandData } from "../mock";

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.getElementById("about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #151515 0%, #1a1a2e 50%, #151515 100%)"
      }}
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div
          className="absolute top-20 left-10 w-64 h-64 rounded-full"
          style={{
            background: "radial-gradient(circle, #ff6b35 0%, transparent 70%)",
            filter: "blur(60px)",
            animation: "pulse 4s ease-in-out infinite"
          }}
        />
        <div
          className="absolute bottom-20 right-10 w-96 h-96 rounded-full"
          style={{
            background: "radial-gradient(circle, #4a5aff 0%, transparent 70%)",
            filter: "blur(80px)",
            animation: "pulse 6s ease-in-out infinite"
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div
          className="mb-8 flex justify-center"
          style={{ animation: "fadeIn 1s ease-out" }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/fho35rrj_Screenshot_20250629_143145_Facebook.png"
            alt="Searching Fusion Logo"
            className="h-32 w-32 sm:h-40 sm:w-40 rounded-full object-cover shadow-2xl"
          />
        </div>

        {/* Band Name */}
        <h1
          className="text-5xl sm:text-7xl lg:text-8xl font-black mb-12"
          style={{
            animation: "fadeInUp 1s ease-out 0.2s backwards",
            background: "linear-gradient(90deg, #ff6b35 0%, #00d9ff 50%, #8b5cf6 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text"
          }}
        >
          {bandData.name}
        </h1>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          style={{ animation: "fadeInUp 1s ease-out 0.4s backwards" }}
        >
          <a
            href={bandData.social.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#ff6b35] hover:bg-[#d1503a] text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl"
          >
            Watch on YouTube
          </a>
          <a
            href={`#booking`}
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById("booking");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-[#4a5aff] hover:bg-[#8b5cf6] text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl"
          >
            Book Us for 2026
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 hover:text-white animate-bounce"
        aria-label="Scroll down"
      >
        <ArrowDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
